import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CalcConfigService } from '_services/calc-config.service';
import { Formula } from '../../_models/formula';
import { HelpComponent } from '../../_shared/help/help.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AidYearComponent } from '../../_shared/aid-year/aid-year.component';
import { MatCard } from '@angular/material/card';
import { AsyncPipe } from '@angular/common';
import { UsageComponent } from '../usage/usage.component';
import { KeyboardScrollableDirective } from '../../_shared/directives/keyboard-scrollable.directive';

@Component({
    selector: 'app-formulas',
    templateUrl: './formulas.component.html',
    styleUrls: ['./formulas.component.css'],
    imports: [HelpComponent, MatButton, MatIcon, AidYearComponent, MatCard, UsageComponent, AsyncPipe, KeyboardScrollableDirective]
})
export class FormulasComponent {
  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    public cc: CalcConfigService
  ) {
    this.titleService.setTitle('Formulas' + ' | NPC Admin');
  }

  createFormula(): void {
    this.router.navigate(['new'], { relativeTo: this.route });
  }

  openFormula(formula: Formula): void {
    this.router.navigate([formula.formulaId], { relativeTo: this.route });
  }

  activateFormula(event: Event, formula: Formula): void {
    event.preventDefault();
    event.stopPropagation();
    this.openFormula(formula);
  }

  trackByFormulaId(_index: number, formula: Formula): string {
    return formula.formulaId;
  }
}
